import(/* webpackMode: "eager" */ "/home/kehutanan-web/kehutanan-web/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/kehutanan-web/kehutanan-web/src/components/left-button.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/kehutanan-web/kehutanan-web/src/components/markdown-renderer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/kehutanan-web/kehutanan-web/src/components/share.comp.tsx");
